import { Actor, Keys, Scene, Vector } from "excalibur";
import { Player } from "./../../player";
import { OpenHive } from "./../../actors/openHive";
import { goToScene } from "../../main";
import { Resources } from "../../Resources";
import {
  createConfirmation,
  getRandomBetween,
  gotStung,
  sendAlert,
  startStingTimer,
} from "../../utils";
import {
  hiveState,
  inventoryState,
  playerState,
} from "../../state/stateManager";

export default class HiveMenu extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;

    this.activeItem = 0;
    this.selected = null;
    this.menuItems = 9;
    this.playerAnim = false;
    this.stingTimer = null;
  }
  stopTimer() {
    this.stingTimer.stop();
  }
  onActivate(data) {
    this.hiveStats = data.data;
    console.log("data from activation: ", data);

    const hive = new OpenHive(335, 170, this.hiveStats);

    this.hive = hive;
    this.activeItem = 0;
    this.hive.hiveStats = this.hiveStats;
    this.camera.zoom = 4;
    this.add(this.player);
    this.add(this.hive);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.classList.remove("beeMarketCommerce");
    this.menuContainer.style.display = "flex";
    this.menu = document.getElementById("hive-menu");
    this.menu.style.display = "block";
    this.menu.innerHTML = `<h1>Hive: ${data.data.id}</h1> ${getMenu(0)}`;
    // if (this.stingTimer == null){
    //   this.startStingTimer()
    // }
    // if (
    //   this.hiveStats.lastSmoked == null ||
    //   new Date().getTime() - this.hiveStats.lastSmoked > 10000
    // ) {
    //   this.shouldSting();
    // }
    if (this.hiveStats.alive) {
      Resources.BeeSounds.loop = true;
      Resources.BeeSounds.play();
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "menu",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            this.stopTimer();
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  // shouldSting() {
  //   let aggression = this.hiveStats.aggression;
  //   let shouldSting = false;
  //   let random = Math.random();
  //   if (random <= aggression) {
  //     gotStung(this.camera);
  //   }
  // }
  onPreUpdate() {
    console.log("playerAnim: ", this.playerAnim);
    if (!this.playerAnim) {
      this.player.doAnim("leftIdleBobble");
    } else {
      this.player.doAnim("left-smoke");
    }
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      console.log("pressed up");
      Resources.Click.play();
      if (this.activeItem > 0) {
        this.activeItem = this.activeItem - 1;
      } else {
        this.activeItem = this.menuItems - 1;
      }
      this.menu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>${getMenu(
        this.activeItem
      )}`;
      return;
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      console.log("pressed down");
      Resources.Click.play();
      if (this.activeItem < this.menuItems - 1) {
        this.activeItem++;
      } else {
        this.activeItem = 0;
      }

      this.menu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>${getMenu(
        this.activeItem
      )}`;
      return;
    }
    if (this.engine.input.keyboard.wasPressed(Keys.S)) {
      console.log("setting lastSmoked");
      let hives = hiveState.getHives();
      hives.forEach((hi, i) => {
        if (hi.birth === this.hiveStats.birth) {
          hi.lastSmoked = new Date().getTime();
        }
      });
      hiveState.setHives(hives);
      if (!this.playerAnim) {
        console.log("setting leftSmoke playerAnim");
        this.setPlayerAnim("left-smoke");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      console.log("pressed x should go back");
      //go back
      Resources.BeeSounds.stop();
      this.stingTimer.stop();
      if (this.hiveStats.position.yard == "home") {
        goToScene("home");
      } else {
        goToScene("back40", {
          x: this.hiveStats.position.x,
          y: this.hiveStats.position.y,
        });
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      console.log("enterPress: activeItem is: ", this.activeItem);
      Resources.Inventory.play();
      switch (this.activeItem) {
        case 0:
          this.selected = 0;
          this.menu.style.display = "none";

          goToScene("boxesMenu", this.hiveStats);
          break;
        case 1:
          this.selected = 1;
          this.menu.style.display = "none";
          this.stingTimer && this.stingTimer.stop();

          goToScene("inspect", this.hiveStats);

          break;
        case 2:
          this.selected = 2;
          this.menu.style.display = "none";
          goToScene("feedingMenu", this.hiveStats);
          break;
        case 3:
          this.selected = 3;
          //harvest
          this.menu.style.display = "none";
          goToScene("harvestMenu", this.hiveStats);
          break;
        case 4:
          this.selected = 4;
          //mite
          this.menu.style.display = "none";
          goToScene("miteMenu", this.hiveStats);
          break;
        case 5:
          this.selected = 5;

          //mite
          this.menu.style.display = "none";
          goToScene("requeenMenu", this.hiveStats);
          break;
        case 6:
          this.selected = 6;
          //split
          this.menu.style.display = "none";
          goToScene("splitMenu", this.hiveStats);
          break;
        case 7:
          this.selected = 7;
          //split
          this.menu.style.display = "none";
          goToScene("askGrandpa", this.hiveStats);
          break;
        case 8:
          this.selected = 8;
          //askGrandpa
          this.menu.style.display = "none";
          createConfirmation(
            "Are You Sure You Want To Remove This Hive? This Cannot Be Undone."
          ).then(() => {
            //should remove hive
            let boxes = this.hiveStats.overallFrames.count / 10;
            let inventory = inventoryState.getInventory();
            inventory.boxes = inventory.boxes + boxes;
            let hives = hiveState.getHives();
            let newHives = [];
            hives.forEach((hi, i) => {
              if (hi.birth !== this.hiveStats.birth) {
                newHives.push(hi);
              }
            });
            hiveState.setHives(newHives);
            this.stingTimer && this.stingTimer.stop();
            goToScene("home");
          });
          break;
        default:
          break;
      }
    }
  }

  onDeactivate() {
    this.stingTimer && this.stingTimer.stop();
    this.selected = 0;
    this.hive.kill();
    this.menuContainer.style.display = "none";
    this.menu.innerHTML = "";
    this.menu.style.display = "none";
  }
}

function getMenu(selected) {
  console.log("pressed: getmenu");
  switch (selected) {
    case 0:
      return `
      <ul>
      <li id="list0" class="listItem"><span id="selector">></span>Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
      <li id="list7">Ask Grandpa</li>
      <li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;
    case 1:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1"><span id="selector">></span>Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
      <li id="list7">Ask Grandpa</li><li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;

    case 2:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2"><span id="selector">></span>Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
      <li id="list7">Ask Grandpa</li><li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;
    case 3:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3"><span id="selector">></span>Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
      <li id="list7">Ask Grandpa</li><li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;
    case 4:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4"><span id="selector">></span>Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
      <li id="list7">Ask Grandpa</li><li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;
    case 5:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5"><span id="selector">></span>Requeen</li>
      <li id="list6">Split</li>
      <li id="list7">Ask Grandpa</li><li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;
    case 6:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6"><span id="selector">></span>Split</li>
      <li id="list7">Ask Grandpa</li><li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;
    case 7:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
      <li id="list7"><span id="selector">></span>Ask Grandpa</li><li id="list7">Remove Hive (Deadout)</li>
    </ul>`;
      break;
    case 8:
      return `<ul>
      <li id="list0" class="listItem">Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
      <li id="list7">Ask Grandpa</li><li id="list7"><span id="selector">></span>Remove Hive (Deadout)</li>
    </ul>`;
      break;
    default:
      return `<ul>
      <li id="list0" class="listItem"><span id="selector">></span>Manage Boxes</li>
      <li id="list1">Inspect</li>
      <li id="list2">Feed</li>
      <li id="list3">Harvest</li>
      <li id="list4">Mite Management</li>
      <li id="list5">Requeen</li>
      <li id="list6">Split</li>
    </ul>`;
      break;
  }
}
